import { render, staticRenderFns } from "./formInstagram.vue?vue&type=template&id=44d567ce"
import script from "./formInstagram.vue?vue&type=script&lang=js"
export * from "./formInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d567ce')) {
      api.createRecord('44d567ce', component.options)
    } else {
      api.reload('44d567ce', component.options)
    }
    module.hot.accept("./formInstagram.vue?vue&type=template&id=44d567ce", function () {
      api.rerender('44d567ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formInstagram.vue"
export default component.exports